// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-slider .swiper-pagination .swiper-pagination-bullet{height:0.75rem;width:0.75rem;border-width:1px;border-style:solid;--tw-border-opacity:1;border-color:rgb(206 184 136 / var(--tw-border-opacity));--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity));opacity:1}.m-slider .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{--tw-bg-opacity:1;background-color:rgb(206 184 136 / var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
